import React, {FC, useEffect} from "react";
import {ScreenProps} from "../types/appTypes";
import {AuthResponseData, handleNewLogin} from "../services/authService";

const DMF_PRO_ORIGIN = process.env.REACT_APP_DMF_PRO_ORIGIN

const LoginFromDMFPro: FC<ScreenProps> = () => {
  useEffect(() => {
    function listenToMessageFromDMFPro(e: MessageEvent<{data: AuthResponseData, headers: any}>) {
      if (!DMF_PRO_ORIGIN || e.origin !== new URL(DMF_PRO_ORIGIN).origin || e.source !== window.parent) {
        return; // Wrong origin
      }
      try {
        handleNewLogin(e.data.data, e.data.headers)
      } catch(err) {
        console.error("line 16, login-from-dmf-pro.tsx", err)
      }
      finally {
        window.parent.postMessage({completed: true}, new URL(DMF_PRO_ORIGIN!).origin)
      }
    }

    window.addEventListener('message', listenToMessageFromDMFPro)
    return () => {
      window.removeEventListener('message', listenToMessageFromDMFPro)
    }
  }, []);

  return (
    <></>
  )
};

export default LoginFromDMFPro;
